<div
    #HorizontalScrollerContainer
    [style.transform]="'translateX(' + translateXPosition + ')'"
    [style.transition-duration]="duration + 's'"
    (transitionstart)="animationStart()"
    (transitionend)="animationDone()"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)"
    class="horizontal-container">
    <ng-content></ng-content>
</div>
